module.exports = __webpack_public_path__ + "media/customizations/nolina/back-5621f1df015eeb1fc199307076ddae62.jpg";